import React, { Context, use, useEffect, useState } from "react";

export type SearchHitContextValues = {
    queryID?: string;
    position?: number;
};

const defaultContext: SearchHitContextValues = {
    position: NaN
};

const SearchHitContext: Context<SearchHitContextValues> =
    React.createContext<SearchHitContextValues>(defaultContext);

export type SearchHitProviderProps = {
    children?: React.ReactNode;
    queryID?: string;
    position?: number;
};

const SearchHitContextProvider = ({
    children,
    queryID,
    position
}: SearchHitProviderProps) => {
    const [queryIDValue, setQueryID] = useState(queryID);
    const [positionValue, setPosition] = useState(position);

    useEffect(() => {
        setQueryID(queryID);
    }, [queryID]);

    useEffect(() => {
        setPosition(position);
    }, [position]);

    return (
        <SearchHitContext
            value={{
                queryID: queryIDValue,
                position: positionValue
            }}
        >
            {children}
        </SearchHitContext>
    );
};

const useSearchHitContext = (): SearchHitContextValues => {
    const context = use<SearchHitContextValues>(SearchHitContext);
    if (context === undefined) {
        throw new Error("useSearchHit is undefined.");
    }
    return context;
};

export { SearchHitContextProvider, useSearchHitContext };
